import { StarRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasStarPicker } from "../constants";

import { DefaultCanvasStarPicker } from "./star-picker";

let loadStarPick = !1;

export function bindStarCanvasPickerContribution(container) {
    var _a;
    loadStarPick || (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, StarRender)) && (loadStarPick = !0, 
    container.bind(CanvasStarPicker).toDynamicValue((() => new DefaultCanvasStarPicker(resolveContainerBinding(container, StarRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasStarPicker));
}
//# sourceMappingURL=star-module.js.map
